import {StoichiometryStructuredTableRowMetadata} from 'notebook/integrations/chemistry/StoichiometryStructuredTableAdapter';
import {UnknownStructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import {EvaluatedCell} from 'notebook/tables/excess/Evaluator';
import * as Util from 'notebook/tables/excess/Util';

export default function attachUnrecognizedMoleculeResolutionActions(
  computedTable: Array<Array<EvaluatedCell>> | null | undefined,
  structuredTable: UnknownStructuredTable,
  getResolutionAction?: (canonicalSmiles: string) => () => void
): void {
  if (!getResolutionAction || !computedTable) {
    return;
  }
  for (let rowIndex = 0; rowIndex < computedTable.length; rowIndex++) {
    const row = computedTable[rowIndex];
    const rowMetadata = structuredTable.rows[rowIndex]?.metadata as
      | StoichiometryStructuredTableRowMetadata
      | undefined;
    const canonicalSmiles = rowMetadata?.canonicalSmiles;
    if (!canonicalSmiles) {
      continue;
    }
    for (const cell of row) {
      if (cell.error) {
        const errors = Array.isArray(cell.error) ? cell.error : [cell.error];
        for (const error of errors) {
          if (Util.isUnrecognizedMoleculeWarning(error) && !error.resolutionAction) {
            error.resolutionAction = getResolutionAction(canonicalSmiles);
            error.resolutionActionLabel = 'Create molecule';
          }
        }
      }
    }
  }
}
